import React, { useContext, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { Breadcrumb, Image, Toast } from "react-bootstrap";
import { get, find, isEmpty } from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons";
import { InnerLayoutButtons } from "..";
import {
  manageMasterStore,
  setManageMasterFlow,
  setManageMasterToastInfo,
} from "../../contexts";
import { LoaderWrapper } from "../../components";
import { useDeepEffect, useRouterParams } from "../../abstracts";
import {
  MANAGE_MASTERS_ROUTES,
  ROUTES,
  manageMapperFormNames,
  apiErrors,
  getPathWithParam,
  ALL_MANAGE_MASTER_ROUTES,
} from "../../utils";
import { useFormikContext } from "formik";
import Cancel from "../../styles/cancel.png";
import RouteLeavingGuard from "../RouteLeavingGuard";

const ManageMastersLayout = ({
  rptName,
  children,
  buttons = [],
  tabs,
  pageFlow,
  layoutHeader,
  customBreadCrumbs,
  history,
  donotShowBreadcrumbs,
}) => {
  const [showError, setShowError] = useState(false);
  const { state, dispatch } = useContext(manageMasterStore);

  const { showToast, toastMessage } = state;
  const [dataLoading, setDataLoading] = useState(false);
  const apiError = get(state, "api.error", {});
  const apiData = get(state, "api.data", {});
  const {
    isSubmitting,
    dirty,
    resetForm,
    setSubmitting,
  } = useFormikContext() || { dirty: false };

  const onRefresh = () => {
    if (resetForm) {
      resetForm();
      setSubmitting(false);
    }
  };

  const menuDetails = find(ALL_MANAGE_MASTER_ROUTES, (item) => {
    if (get(state, "selectedMenu", "").indexOf(get(item, "path")) !== -1) {
      return true;
    }
    return false;
  });

  useDeepEffect(() => {
    if (isEmpty(apiData)) {
      setDataLoading(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiData]);

  useDeepEffect(
    () => {
      if (!isEmpty(apiError)) {
        setShowError(true);
      }
    },
    [apiError],
    true
  );

  const errorStatus = get(apiError, "response.status", 500);
  const errorData = apiErrors[errorStatus];
  return (
    <LoaderWrapper isLoading={false}>
      <div className="d-flex flex-column manage-master-layout">
        <div className="d-flex flex-column overflow-hidden">
          <div className="d-flex align-items-center master-layout-header">
            <div>
              {/* {donotShowBreadcrumbs ? (
                <></>
              ) : (
                <Breadcrumb>
                  {breadCrumOptions.slice(-4).map((item, index) => (
                    <Breadcrumb.Item key={index}>
                      <Link to={item.link}>{item.label}</Link>
                    </Breadcrumb.Item>
                  ))}
                </Breadcrumb>
              )} */}
              {/* <div className="title-case">{}</div> */}
              <h5>{layoutHeader || get(menuDetails, "contentHeader", "")}</h5>
            </div>
            {/* <div className="d-flex align-items-center justify-content-center tab-wrapper">
            {tabs}
          </div> */}
            <div className="ml-auto" style={{ marginRight: "5px" }}>
              <InnerLayoutButtons
                menu="mapper"
                subMenu={
                  menuDetails
                    ? get(menuDetails, "id", "")
                    : "loadDefinitionHome"
                }
                buttonsList={buttons}
                flow={pageFlow}
              />
              {showError && (
                <div
                  className={`error-banner justify-content-between d-flex align-items-center ${
                    (showError && "enable") || ""
                  }`}
                >
                  <div>
                    <Image src={Cancel} width="30px" />
                  </div>
                  <div>
                    <div className="error-heading">{errorData.heading}</div>
                    <div className="error-reason">{errorData.reason}</div>
                  </div>
                  <div>
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      color="#000"
                      style={{ fontSize: "14px" }}
                      onClick={() => setShowError(false)}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="layout-content">{children}</div>
          <Toast
            onClose={() =>
              dispatch(
                setManageMasterToastInfo({
                  showToast: false,
                  toastMessage: "",
                })
              )
            }
            show={showToast}
            style={{
              position: "fixed",
              top: "8rem",
              right: "4rem",
              zIndex: "100",
            }}
            delay={3000}
            autohide
          >
            <Toast.Body className="success-toast-align">
              <div className="mr-2">
                {showToast ? (
                  <FontAwesomeIcon
                    icon={faCheckCircle}
                    color="#3BB54A"
                    size="lg"
                  />
                ) : (
                  ""
                )}
              </div>
              <div>{toastMessage}</div>
              <div className="ml-2">
                {showToast ? (
                  <FontAwesomeIcon
                    icon={faTimesCircle}
                    color="#000000"
                    size="md"
                    onClick={() =>
                      dispatch(
                        setManageMasterToastInfo({
                          showToast: false,
                          toastMessage: "",
                        })
                      )
                    }
                  />
                ) : (
                  ""
                )}
              </div>
            </Toast.Body>
          </Toast>
          <RouteLeavingGuard
            when={!isSubmitting && dirty}
            navigate={(path) => history.push(path)}
            onRefresh={onRefresh}
          />
        </div>
      </div>
    </LoaderWrapper>
  );
};

export default withRouter(ManageMastersLayout);
